
import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { logger } from '@/utils/logger';

const Index = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  
  logger.info("Index page - Auth state:", { user: !!user, loading });

  useEffect(() => {
    // If user is already logged in, redirect to dashboard
    if (user && !loading) {
      logger.info("Index: User is logged in, redirecting to companies");
      navigate('/companies');
    }
  }, [user, loading, navigate]);

  // Show a simple loading indicator while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="text-center">
          <CardTitle className="text-3xl font-bold">Marketing Mary</CardTitle>
          <CardDescription>
            AI-Powered Marketing Assistant for Your Business
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <p className="text-gray-600">
            Marketing Mary analyzes your business, identifies your ideal customers, and provides expert marketing advice.
          </p>
          <div className="grid grid-cols-2 gap-4 mt-6">
            <div className="flex flex-col items-center p-3 rounded-lg bg-blue-50">
              <div className="text-blue-500 font-semibold">Website Analysis</div>
              <p className="text-sm text-gray-500">Extract insights from your website</p>
            </div>
            <div className="flex flex-col items-center p-3 rounded-lg bg-green-50">
              <div className="text-green-500 font-semibold">Persona Creation</div>
              <p className="text-sm text-gray-500">Identify your ideal customers</p>
            </div>
          </div>
        </CardContent>
        <CardFooter className="flex justify-center space-x-4">
          <Link to="/auth">
            <Button className="bg-blue-600 hover:bg-blue-700">
              Get Started
            </Button>
          </Link>
          <Link to="/pricing">
            <Button variant="outline">
              View Pricing
            </Button>
          </Link>
        </CardFooter>
      </Card>
    </div>
  );
};

export default Index;
